import React from "react";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import { Box, Modal } from "@mui/material";
import GynacEmr from "./GynacEmr";

const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  width: "97%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  overflowY: "auto",
  p: 1,
};

function GynecologyEmr(props) {
  return (
    <div>
      <Modal
        open={props?.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyles} className="h-[95%]">
          <div className="px-2">
            <div className="flex justify-between">
              <div className=" "></div>
              <div className="flex items-center">
                <button
                  onClick={() => {
                    props?.close();
                  }}
                  type="button"
                >
                  <CancelPresentationIconButton />
                </button>
              </div>
            </div>
            <div>
              <GynacEmr />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default GynecologyEmr;
